import { COOKIE_NAME, LogoutIcon, useTelegram } from '@foxtaibox/foxtailbox-frontend-core';
import { Button, styled, Typography } from '@mui/material';
import client, { isTelegram } from 'config/apolloConfig';
import ROUTES from 'constants/routes';
import useNavigateWithReplace from 'hooks/useNavigateReplace';
import cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { $user, userLogout } from 'store/user/model';
import { removeItem } from 'utils/cloudStorage';

interface ILogoutButtonProps {
  isMobile: boolean;
}

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    width: '100%',
    '&:hover, &:active': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
}));

const LogoutButton = ({ isMobile }: ILogoutButtonProps) => {
  const navigate = useNavigate();
  const { tg } = useTelegram();
  const { isAssessmentView, showPreventNavigateModal } = useNavigateWithReplace();

  const logout = () => {
    if (isTelegram) {
      tg?.close();
    } else {
      localStorage.clear();
      if (isTelegram) {
        removeItem(COOKIE_NAME.ACCESS_TOKEN);
        removeItem(COOKIE_NAME.REFRESH_TOKEN);
      } else {
        cookies.remove(COOKIE_NAME.ACCESS_TOKEN);
        cookies.remove(COOKIE_NAME.REFRESH_TOKEN);
      }
      userLogout();
      $user.watch((state) => {
        if (state === null) {
          client.resetStore().then(() => navigate(ROUTES.LOGIN));
        }
      });
    }
  };

  const handleLogout = () => {
    if (isAssessmentView) {
      showPreventNavigateModal({
        onConfirm: () => logout(),
      });
    } else logout();
  };

  return (
    <StyledButton onClick={handleLogout}>
      {isMobile && <Typography sx={{ color: '#fff', marginRight: 1 }}>Выйти</Typography>}
      <LogoutIcon sx={{ color: { md: 'primary.main', xs: '#fff' }, width: 32, height: 32 }} />
    </StyledButton>
  );
};

export default LogoutButton;
